/**
 * Created by josh on 2017/8/11.
 */

import ButtonCheckbox from '../button/src/button-checkbox.vue';

/* istanbul ignore next */
ButtonCheckbox.install = function(Vue) {
    Vue.component(ButtonCheckbox.name, ButtonCheckbox);
};

export default ButtonCheckbox;


// WEBPACK FOOTER //
// ./src/plugin-api/packages/button-checkbox/index.js